import { useState } from "react";
import { useApp } from "../context/AppContext";
import { BOT_INVITE_URL } from "../config";

const API_BASE = import.meta.env.VITE_API_URL || "";

export default function ApiKeysPage() {
  const {
    apiKeys, loadingKeys, fetchKeys, fetchModels, showToast, trackEvent
  } = useApp();
  const [provider, setProvider] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [addError, setAddError] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const GOOGLE_KEY_HINT = "AIza...";
  const PROVIDER_DOCS = {
    openai: "https://platform.openai.com/api-keys",
    anthropic: "https://console.anthropic.com/settings/keys",
    google: "https://aistudio.google.com/app/apikey",
    xai: "https://console.x.ai",
    groq: "https://console.groq.com/keys",
    perplexity: "https://docs.perplexity.ai/docs/api-intro",
    openrouter: "https://openrouter.ai/keys",
    okeybot: "",
  };

  const PROVIDER_DASHBOARDS = {
    openai: "https://platform.openai.com/usage",
    anthropic: "https://console.anthropic.com/settings/usage",
    google: "https://aistudio.google.com/app/apikey",
    xai: "https://console.x.ai",
    groq: "https://console.groq.com/usage",
    perplexity: "https://www.perplexity.ai/settings/api",
    openrouter: "https://openrouter.ai/dashboard",
    okeybot: "",
  };

  const PROVIDER_ICONS = {
    openai: (
      <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
        <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" />
      </svg>
    ),
    anthropic: (
      <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.3041 3.541h-3.6718l6.696 16.918H24Zm-10.6082 0L0 20.459h3.7442l1.3693-3.5527h7.0052l1.3693 3.5528h3.7442L10.5363 3.5409Zm-.3712 10.2232 2.2914-5.9456 2.2914 5.9456Z" />
      </svg>
    ),
    google: (
      <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.545 10.239v3.821h5.445c-.712 2.315-2.647 3.972-5.445 3.972a6.033 6.033 0 110-12.064c1.498 0 2.866.549 3.921 1.453l2.814-2.814A9.969 9.969 0 0012.545 2C7.021 2 2.543 6.477 2.543 12s4.478 10 10.002 10c8.396 0 10.249-7.85 9.426-11.748l-9.426-.013z" />
      </svg>
    ),
    xai: (
      <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
    groq: (
      <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.036 2c-3.853-.035-7 3-7.036 6.781-.035 3.782 3.055 6.872 6.908 6.907h2.42v-2.566h-2.292c-2.407.028-4.38-1.866-4.408-4.23-.029-2.362 1.901-4.298 4.308-4.326h.1c2.407 0 4.358 1.915 4.365 4.278v6.305c0 2.342-1.944 4.25-4.323 4.279a4.375 4.375 0 01-3.033-1.252l-1.851 1.818A7 7 0 0012.029 22h.092c3.803-.056 6.858-3.083 6.879-6.816v-6.5C18.907 4.963 15.817 2 12.036 2z" />
      </svg>
    ),
    perplexity: (
      <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.785 0v7.272H22.5V17.62h-2.935V24l-7.037-6.194v6.145h-1.091v-6.152L4.392 24v-6.465H1.5V7.188h2.884V0l7.053 6.494V.19h1.09v6.49L19.786 0zm-7.257 9.044v7.319l5.946 5.234V14.44l-5.946-5.397zm-1.099-.08l-5.946 5.398v7.235l5.946-5.234V8.965zm8.136 7.58h1.844V8.349H13.46l6.105 5.54v2.655zm-8.982-8.28H2.59v8.195h1.8v-2.576l6.192-5.62zM5.475 2.476v4.71h5.115l-5.115-4.71zm13.219 0l-5.115 4.71h5.115v-4.71z" />
      </svg>
    ),
    openrouter: (
      <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
        <path d="M16.804 1.957l7.22 4.105v.087L16.73 10.21l.017-2.117-.821-.03c-1.059-.028-1.611.002-2.268.11-1.064.175-2.038.577-3.147 1.352L8.345 11.03c-.284.195-.495.336-.68.455l-.515.322-.397.234.385.23.53.338c.476.314 1.17.796 2.701 1.866 1.11.775 2.083 1.177 3.147 1.352l.3.045c.694.091 1.375.094 2.825.033l.022-2.159 7.22 4.105v.087L16.589 22l.014-1.862-.635.022c-1.386.042-2.137.002-3.138-.162-1.694-.28-3.26-.926-4.881-2.059l-2.158-1.5a21.997 21.997 0 00-.755-.498l-.467-.28a55.927 55.927 0 00-.76-.43C2.908 14.73.563 14.116 0 14.116V9.888l.14.004c.564-.007 2.91-.622 3.809-1.124l1.016-.58.438-.274c.428-.28 1.072-.726 2.686-1.853 1.621-1.133 3.186-1.78 4.881-2.059 1.152-.19 1.974-.213 3.814-.138l.02-1.907z" />
      </svg>
    ),
    okeybot: (
      <svg width={24} height={24} viewBox="0 0 256 256" fill="currentColor">
        <circle cx="128" cy="128" r="128" />
        <ellipse cx="86" cy="128" rx="36" ry="32" fill="#000000" />
        <rect x="91" y="117" width="86" height="22" rx="14" fill="#000000" />
        <rect x="148" y="100" width="60" height="55" rx="10" fill="#000000" />
      </svg>
    ),
  };
  // Helper function to check if a provider already has a key
  function hasKeyForProvider(providerName) {
    return apiKeys?.some(k => k.provider === providerName) || false;
  }

  // Helper function to get the key object for a provider
  function getKeyForProvider(providerName) {
    return apiKeys?.find(k => k.provider === providerName);
  }

  // Handle provider selection - toggle on/off for any provider
  function handleProviderClick(providerId) {
    if (provider === providerId) {
      // Clicking the same provider again - deselect it
      setProvider("");
      setApiKey("");
      setAddError(null);
    } else {
      // Selecting a different provider
      setProvider(providerId);
      setApiKey("");
      setAddError(null);
    }
  }

  function handleAdd() {
    if (!provider || !apiKey) return;
    const trimmedKey = apiKey.trim();
    if (trimmedKey.length < 20) {
      showToast("API key seems too short", "error");
      return;
    }
    setLoading(true);
    setAddError(null);
    fetch(`${API_BASE}/api/apikeys`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ provider, api_key: trimmedKey }),
    })
      .then(async r => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) {
          const msg = (data && data.error) ? String(data.error) : "Failed to add API key";
          const details = (data && data.details) ? String(data.details) : undefined;
          setAddError({ message: msg, details });
          showToast(msg, "error");
          throw new Error(msg);
        }
        const modelsFound = typeof data?.models_found === "number" ? data.models_found : undefined;
        const successMsg = modelsFound !== undefined
          ? `Verified ${provider} key • ${modelsFound} model${modelsFound === 1 ? "" : "s"} found`
          : `Verified ${provider} API key`;
        showToast(successMsg, "success");
        trackEvent("add_api_key_success", { provider, models_found: modelsFound });
        setProvider("");
        setApiKey("");
        fetchKeys();
        fetchModels();
      })
      .catch(e => {
        // already surfaced via toast; keep for safety
        if (e?.message && !addError) showToast(e.message, "error");
      })
      .finally(() => setLoading(false));
  }

  function handleDelete(id, providerName) {
    setDeleteConfirm(null);
    setLoading(true);
    fetch(`${API_BASE}/api/apikeys/${id}`, {
      method: "DELETE",
      credentials: "include",
    })
      .then(() => {
        showToast(`Removed ${providerName} API key`, "info");
        // If we just deleted the currently selected provider, clear the selection
        if (provider === providerName) {
          setProvider("");
          setApiKey("");
        }
        fetchKeys();
        fetchModels();
      })
      .finally(() => setLoading(false));
  }

  return (
    <>
      <div className="card">
        <div className="card-header">
          <svg className="card-icon" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
          <h2>Add New API Key</h2>
        </div>
        <div className="provider-selection">
          <label className="form-label">Choose Provider</label>
          <div className="provider-cards">
            <div
              className={`provider-card ${provider === "openai" && hasKeyForProvider("openai") ? "selected" : ""} ${hasKeyForProvider("openai") ? "has-key" : ""}`}
              onClick={() => handleProviderClick("openai")}
              style={{ cursor: "pointer" }}
            >
              <div className="provider-icon">
                <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" />
                </svg>
              </div>
              <div className="provider-name">OpenAI</div>
              {hasKeyForProvider("openai") ? (
                <div style={{
                  fontSize: "0.75rem",
                  color: "var(--text-muted)",
                  marginTop: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.25rem"
                }}>
                  <svg width={14} height={14} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                  Configured
                </div>
              ) : (
                <a
                  href="https://platform.openai.com/api-keys"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="provider-link"
                  onClick={e => e.stopPropagation()}
                >
                  Get Key →
                </a>
              )}
            </div>
            <div
              className={`provider-card ${provider === "anthropic" && hasKeyForProvider("anthropic") ? "selected" : ""} ${hasKeyForProvider("anthropic") ? "has-key" : ""}`}
              onClick={() => handleProviderClick("anthropic")}
              style={{ cursor: "pointer" }}
            >
              <div className="provider-icon">
                <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.3041 3.541h-3.6718l6.696 16.918H24Zm-10.6082 0L0 20.459h3.7442l1.3693-3.5527h7.0052l1.3693 3.5528h3.7442L10.5363 3.5409Zm-.3712 10.2232 2.2914-5.9456 2.2914 5.9456Z" />
                </svg>
              </div>
              <div className="provider-name">Anthropic</div>
              {hasKeyForProvider("anthropic") ? (
                <div style={{
                  fontSize: "0.75rem",
                  color: "var(--text-muted)",
                  marginTop: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.25rem"
                }}>
                  <svg width={14} height={14} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                  Configured
                </div>
              ) : (
                <a
                  href="https://console.anthropic.com/settings/keys"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="provider-link"
                  onClick={e => e.stopPropagation()}
                >
                  Get Key →
                </a>
              )}
            </div>
            <div
              className={`provider-card ${provider === "google" && hasKeyForProvider("google") ? "selected" : ""} ${hasKeyForProvider("google") ? "has-key" : ""}`}
              onClick={() => handleProviderClick("google")}
              style={{ cursor: "pointer" }}
            >
              <div className="provider-icon">
                <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.545 10.239v3.821h5.445c-.712 2.315-2.647 3.972-5.445 3.972a6.033 6.033 0 110-12.064c1.498 0 2.866.549 3.921 1.453l2.814-2.814A9.969 9.969 0 0012.545 2C7.021 2 2.543 6.477 2.543 12s4.478 10 10.002 10c8.396 0 10.249-7.85 9.426-11.748l-9.426-.013z" />
                </svg>
              </div>
              <div className="provider-name">Google</div>
              {hasKeyForProvider("google") ? (
                <div style={{
                  fontSize: "0.75rem",
                  color: "var(--text-muted)",
                  marginTop: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.25rem"
                }}>
                  <svg width={14} height={14} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                  Configured
                </div>
              ) : (
                <a
                  href="https://aistudio.google.com/app/apikey"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="provider-link"
                  onClick={e => e.stopPropagation()}
                >
                  Get Key →
                </a>
              )}
            </div>
            <div
              className={`provider-card ${provider === "xai" && hasKeyForProvider("xai") ? "selected" : ""} ${hasKeyForProvider("xai") ? "has-key" : ""}`}
              onClick={() => handleProviderClick("xai")}
              style={{ cursor: "pointer" }}
            >
              <div className="provider-icon">
                <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </div>
              <div className="provider-name">xAI</div>
              {hasKeyForProvider("xai") ? (
                <div style={{
                  fontSize: "0.75rem",
                  color: "var(--text-muted)",
                  marginTop: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.25rem"
                }}>
                  <svg width={14} height={14} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                  Configured
                </div>
              ) : (
                <a
                  href="https://console.x.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="provider-link"
                  onClick={e => e.stopPropagation()}
                >
                  Get Key →
                </a>
              )}
            </div>
            <div
              className={`provider-card ${provider === "perplexity" && hasKeyForProvider("perplexity") ? "selected" : ""} ${hasKeyForProvider("perplexity") ? "has-key" : ""}`}
              onClick={() => handleProviderClick("perplexity")}
              style={{ cursor: "pointer" }}
            >
              <div className="provider-icon">
                <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.785 0v7.272H22.5V17.62h-2.935V24l-7.037-6.194v6.145h-1.091v-6.152L4.392 24v-6.465H1.5V7.188h2.884V0l7.053 6.494V.19h1.09v6.49L19.786 0zm-7.257 9.044v7.319l5.946 5.234V14.44l-5.946-5.397zm-1.099-.08l-5.946 5.398v7.235l5.946-5.234V8.965zm8.136 7.58h1.844V8.349H13.46l6.105 5.54v2.655zm-8.982-8.28H2.59v8.195h1.8v-2.576l6.192-5.62zM5.475 2.476v4.71h5.115l-5.115-4.71zm13.219 0l-5.115 4.71h5.115v-4.71z" />
                </svg>
              </div>
              <div className="provider-name">Perplexity</div>
              {hasKeyForProvider("perplexity") ? (
                <div style={{
                  fontSize: "0.75rem",
                  color: "var(--text-muted)",
                  marginTop: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.25rem"
                }}>
                  <svg width={14} height={14} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                  Configured
                </div>
              ) : (
                <a
                  href="https://docs.perplexity.ai/docs/api-intro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="provider-link"
                  onClick={e => e.stopPropagation()}
                >
                  Get Key →
                </a>
              )}
            </div>
            <div
              className={`provider-card ${provider === "groq" && hasKeyForProvider("groq") ? "selected" : ""} ${hasKeyForProvider("groq") ? "has-key" : ""}`}
              onClick={() => handleProviderClick("groq")}
              style={{ cursor: "pointer" }}
            >
              <div className="provider-icon">
                <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.036 2c-3.853-.035-7 3-7.036 6.781-.035 3.782 3.055 6.872 6.908 6.907h2.42v-2.566h-2.292c-2.407.028-4.38-1.866-4.408-4.23-.029-2.362 1.901-4.298 4.308-4.326h.1c2.407 0 4.358 1.915 4.365 4.278v6.305c0 2.342-1.944 4.25-4.323 4.279a4.375 4.375 0 01-3.033-1.252l-1.851 1.818A7 7 0 0012.029 22h.092c3.803-.056 6.858-3.083 6.879-6.816v-6.5C18.907 4.963 15.817 2 12.036 2z" />
                </svg>
              </div>
              <div className="provider-name">Groq</div>
              {hasKeyForProvider("groq") ? (
                <div style={{
                  fontSize: "0.75rem",
                  color: "var(--text-muted)",
                  marginTop: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.25rem"
                }}>
                  <svg width={14} height={14} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                  Configured
                </div>
              ) : (
                <a
                  href="https://console.groq.com/keys"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="provider-link"
                  onClick={e => e.stopPropagation()}
                >
                  Get Key →
                </a>
              )}
            </div>
            <div
              className={`provider-card ${provider === "openrouter" && hasKeyForProvider("openrouter") ? "selected" : ""} ${hasKeyForProvider("openrouter") ? "has-key" : ""}`}
              onClick={() => handleProviderClick("openrouter")}
              style={{ cursor: "pointer" }}
            >
              <div className="provider-icon">
                <svg width={24} height={24} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16.804 1.957l7.22 4.105v.087L16.73 10.21l.017-2.117-.821-.03c-1.059-.028-1.611.002-2.268.11-1.064.175-2.038.577-3.147 1.352L8.345 11.03c-.284.195-.495.336-.68.455l-.515.322-.397.234.385.23.53.338c.476.314 1.17.796 2.701 1.866 1.11.775 2.083 1.177 3.147 1.352l.3.045c.694.091 1.375.094 2.825.033l.022-2.159 7.22 4.105v.087L16.589 22l.014-1.862-.635.022c-1.386.042-2.137.002-3.138-.162-1.694-.28-3.26-.926-4.881-2.059l-2.158-1.5a21.997 21.997 0 00-.755-.498l-.467-.28a55.927 55.927 0 00-.76-.43C2.908 14.73.563 14.116 0 14.116V9.888l.14.004c.564-.007 2.91-.622 3.809-1.124l1.016-.58.438-.274c.428-.28 1.072-.726 2.686-1.853 1.621-1.133 3.186-1.78 4.881-2.059 1.152-.19 1.974-.213 3.814-.138l.02-1.907z" />
                </svg>
              </div>
              <div className="provider-name">OpenRouter</div>
              {hasKeyForProvider("openrouter") ? (
                <div style={{
                  fontSize: "0.75rem",
                  color: "var(--text-muted)",
                  marginTop: "0.5rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.25rem"
                }}>
                  <svg width={14} height={14} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                  Configured
                </div>
              ) : (
                <a
                  href="https://openrouter.ai/keys"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="provider-link"
                  onClick={e => e.stopPropagation()}
                >
                  Get Key →
                </a>
              )}
            </div>
            <div
              className={`provider-card has-key ${provider === "okeybot" ? "selected" : ""}`}
              onClick={() => handleProviderClick("okeybot")}
              style={{ cursor: "pointer" }}
            >
              <div className="provider-icon">
                {PROVIDER_ICONS.okeybot}
              </div>
              <div className="provider-name">OkeyBot</div>
              <div style={{
                fontSize: "0.75rem",
                color: "var(--text-muted)",
                marginTop: "0.5rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.25rem"
              }}>
                <svg width={14} height={14} fill="currentColor" viewBox="0 0 24 24">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                Built-in
              </div>
            </div>
          </div>
        </div>
        {provider && (
          <div className="form-group" style={{ animation: "slideDown 0.2s ease-out", marginTop: "1.5rem" }}>
            {hasKeyForProvider(provider) || provider === "okeybot" ? (
              // Management section for configured providers
              <>
                <div style={{
                  background: "var(--bg-primary)",
                  padding: "1.5rem",
                  borderRadius: "8px",
                  border: "1px solid var(--border-color)",
                  marginBottom: "1rem"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1.5rem" }}>
                    <div style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "8px",
                      background: "var(--bg-tertiary)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "var(--accent)",
                      flexShrink: 0
                    }}>
                      {PROVIDER_ICONS[provider]}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "var(--text-primary)",
                        marginBottom: "0.25rem",
                        textTransform: "capitalize"
                      }}>
                        {provider === "okeybot" ? "OkeyBot Built-in Models" : `${provider} API Key`}
                      </div>
                      {provider === "okeybot" ? (
                        <div style={{
                          fontSize: "0.875rem",
                          color: "var(--text-muted)",
                          lineHeight: "1.4"
                        }}>
                          Instant access using Okey Credits. No separate provider account or billing required.
                        </div>
                      ) : (
                        <div style={{
                          fontSize: "0.875rem",
                          color: "var(--text-muted)",
                          fontFamily: "monospace",
                          letterSpacing: "0.05em"
                        }}>
                          ••••••••••••••••••••
                        </div>
                      )}
                    </div>
                    <div style={{
                      padding: "0.375rem 0.75rem",
                      background: "rgba(16, 185, 129, 0.1)",
                      border: "1px solid rgba(16, 185, 129, 0.3)",
                      borderRadius: "9999px",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      color: "#10b981",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em"
                    }}>
                      Active
                    </div>
                  </div>

                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "1rem",
                    paddingTop: "1rem",
                    borderTop: "1px solid var(--border-color)"
                  }}>
                    <div style={{ fontSize: "0.875rem", color: "var(--text-muted)" }}>
                      {provider === "okeybot"
                        ? "Managed by OkeyBot"
                        : `Added ${getKeyForProvider(provider)?.created_at
                          ? new Date(getKeyForProvider(provider).created_at).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                          })
                          : "Unknown"}`}
                    </div>
                    <div style={{ display: "flex", gap: "0.75rem" }}>
                      {provider === "okeybot" && (
                        <a
                          href="/dashboard/models"
                          className="btn btn-secondary"
                          style={{
                            padding: "0.5rem 1rem",
                            fontSize: "0.875rem",
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem"
                          }}
                        >
                          Manage Models →
                        </a>
                      )}

                      {provider !== "okeybot" && PROVIDER_DASHBOARDS[provider] && (
                        <a
                          href={PROVIDER_DASHBOARDS[provider]}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-secondary"
                          style={{
                            padding: "0.5rem 1rem",
                            fontSize: "0.875rem",
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem"
                          }}
                          onClick={e => e.stopPropagation()}
                        >
                          <svg width={16} height={16} fill="currentColor" viewBox="0 0 24 24">
                            <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
                          </svg>
                          Dashboard
                        </a>
                      )}
                      {provider !== "okeybot" && (
                        <button
                          className="btn btn-danger"
                          disabled={loading}
                          onClick={() => setDeleteConfirm({ id: getKeyForProvider(provider).id, provider })}
                          style={{
                            padding: "0.5rem 1rem",
                            fontSize: "0.875rem"
                          }}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              // Add new key section for unconfigured providers
              <>
                <div style={{
                  background: "var(--bg-primary)",
                  padding: "1.5rem",
                  borderRadius: "8px",
                  border: "2px solid var(--accent)",
                  boxShadow: "0 0 0 3px rgba(20, 184, 166, 0.1)",
                  marginBottom: "1rem",
                  animation: "slideDown 0.2s ease-out"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1.5rem" }}>
                    <div style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "8px",
                      background: "var(--bg-tertiary)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "var(--accent)",
                      flexShrink: 0
                    }}>
                      {PROVIDER_ICONS[provider]}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "var(--text-primary)",
                        marginBottom: "0.25rem",
                        textTransform: "capitalize"
                      }}>
                        Add {provider} API Key
                      </div>
                      <div style={{
                        fontSize: "0.875rem",
                        color: "var(--text-muted)"
                      }}>
                        {provider === "openai" && "Starts with sk-"}
                        {provider === "anthropic" && "Starts with sk-ant-"}
                        {provider === "google" && "Get from AI Studio"}
                        {provider === "xai" && "From xAI Console"}
                        {provider === "groq" && "Starts with gsk_"}
                        {provider === "perplexity" && "Starts with pk-"}
                        {provider === "openrouter" && "Starts with sk-or-v1-"}
                      </div>
                    </div>
                    {PROVIDER_DOCS[provider] && (
                      <a
                        href={PROVIDER_DOCS[provider]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-secondary"
                        style={{
                          padding: "0.5rem 1rem",
                          fontSize: "0.875rem",
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          whiteSpace: "nowrap"
                        }}
                        onClick={e => e.stopPropagation()}
                      >
                        <svg width={16} height={16} fill="currentColor" viewBox="0 0 24 24">
                          <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
                        </svg>
                        Get Key
                      </a>
                    )}
                  </div>

                  <div style={{ marginBottom: "1rem" }}>
                    <input
                      className="input"
                      type="password"
                      value={apiKey}
                      placeholder={
                        provider === "openai" ? "sk-..." :
                          provider === "anthropic" ? "sk-ant-..." :
                            provider === "google" ? GOOGLE_KEY_HINT :
                              provider === "xai" ? "Enter your xAI API key" :
                                provider === "groq" ? "gsk_..." :
                                  provider === "perplexity" ? "pk-..." :
                                    provider === "openrouter" ? "sk-or-v1-..." :
                                      ""
                      }
                      onChange={e => setApiKey(e.target.value)}
                      style={{
                        fontSize: "0.875rem",
                        fontFamily: "monospace"
                      }}
                    />
                    {apiKey && apiKey.length > 0 && (
                      <div
                        style={{
                          fontSize: "0.875rem",
                          marginTop: "0.5rem",
                          color: apiKey.length >= 20 ? "var(--success)" : "var(--text-muted)",
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem"
                        }}
                      >
                        {apiKey.length >= 20 ? (
                          <>
                            <svg width={16} height={16} fill="currentColor" viewBox="0 0 24 24">
                              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                            </svg>
                            Key format looks good
                          </>
                        ) : (
                          "Key seems too short"
                        )}
                      </div>
                    )}
                  </div>

                  {addError && (
                    <div
                      style={{
                        marginBottom: "1rem",
                        padding: "1rem",
                        borderRadius: "8px",
                        background: "rgba(239, 68, 68, 0.1)",
                        border: "1px solid rgba(239, 68, 68, 0.3)"
                      }}
                    >
                      <div style={{
                        fontWeight: 600,
                        color: "#fca5a5",
                        marginBottom: "0.5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem"
                      }}>
                        <svg width={16} height={16} fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                        </svg>
                        {addError.message}
                      </div>
                      {addError.details && (
                        <div style={{ fontSize: "0.875rem", color: "#fca5a5", marginBottom: "0.5rem" }}>
                          {addError.details}
                        </div>
                      )}
                      {provider && PROVIDER_DOCS[provider] && (
                        <a
                          href={PROVIDER_DOCS[provider]}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#93c5fd",
                            textDecoration: "underline",
                            fontSize: "0.875rem"
                          }}
                          onClick={e => e.stopPropagation()}
                        >
                          Check your {provider.toUpperCase()} API key and account →
                        </a>
                      )}
                    </div>
                  )}

                  <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "0.75rem",
                    paddingTop: "1rem",
                    borderTop: "1px solid var(--border-color)"
                  }}>
                    <button
                      className="btn btn-secondary"
                      onClick={() => {
                        setProvider("");
                        setApiKey("");
                        setAddError(null);
                      }}
                      disabled={loading}
                      style={{
                        padding: "0.5rem 1rem",
                        fontSize: "0.875rem"
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      disabled={!provider || !apiKey || loading}
                      onClick={handleAdd}
                      style={{
                        padding: "0.5rem 1rem",
                        fontSize: "0.875rem"
                      }}
                    >
                      {loading ? "Adding..." : "Add API Key"}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div >

      <div className="card">
        <p className="how-to-keys-intro">
          <strong>Next steps:</strong>
        </p>
        <ol className="how-to-keys-list">
          <li>
            <a
              href={BOT_INVITE_URL}
              className="how-to-keys-link"
              data-umami-event="add_to_discord_keys_page"
            >
              Add the bot
            </a> to your Discord server.
          </li>
          <li>
            Use <code className="inline-code">/chat</code> to start a thread.
          </li>
          <li>
            (Optional) Add keys above or check{" "}
            <a
              href="/dashboard/models"
              className="how-to-keys-link"
            >
              Models
            </a> to customize your provider preferences.
          </li>
        </ol>
      </div>
      <div className="card" style={{ borderLeft: "4px solid var(--accent)", background: "rgba(20, 184, 166, 0.05)" }}>
        <div style={{ fontSize: "0.875rem", color: "var(--text-secondary)", lineHeight: "1.4" }}>
          <strong>💡 Private & Portable:</strong> You can invite OkeyBot to your
          <strong> personal server for private use</strong>, or use it in
          <strong> any server where the bot is present.</strong> Your keys and
          settings follow your account everywhere.
        </div>
      </div>
      {deleteConfirm && (
        <div className="modal-overlay" onClick={() => setDeleteConfirm(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Remove API Key?</h2>
              <button className="modal-close" onClick={() => setDeleteConfirm(null)}>×</button>
            </div>
            <div className="modal-body">
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                padding: "1rem",
                background: "var(--bg-primary)",
                borderRadius: "8px",
                marginBottom: "1rem"
              }}>
                <div style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "8px",
                  background: "var(--bg-tertiary)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--accent)",
                  flexShrink: 0
                }}>
                  {PROVIDER_ICONS[deleteConfirm.provider]}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "var(--text-primary)",
                    marginBottom: "0.25rem",
                    textTransform: "capitalize"
                  }}>
                    {deleteConfirm.provider} API Key
                  </div>
                  <div style={{
                    fontSize: "0.875rem",
                    color: "var(--text-muted)",
                    fontFamily: "monospace"
                  }}>
                    ••••••••••••••••••••
                  </div>
                </div>
              </div>
              <div style={{
                padding: "1rem",
                background: "rgba(239, 68, 68, 0.1)",
                border: "1px solid rgba(239, 68, 68, 0.3)",
                borderRadius: "8px",
                marginBottom: "1rem"
              }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  marginBottom: "0.5rem",
                  color: "#fca5a5",
                  fontWeight: 600
                }}>
                  <svg width={20} height={20} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                  </svg>
                  Warning
                </div>
                <div style={{ fontSize: "0.875rem", color: "#fca5a5" }}>
                  This will disable all {deleteConfirm.provider} models and cannot be undone. You'll need to re-add the API key to use {deleteConfirm.provider} models again.
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setDeleteConfirm(null)}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={() => handleDelete(deleteConfirm.id, deleteConfirm.provider)}
                disabled={loading}
              >
                {loading ? "Removing..." : "Remove API Key"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
